module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.a37b0c01.ttf";